import { render, staticRenderFns } from "./Bara.vue?vue&type=template&id=73264d96&scoped=true&"
import script from "./Bara.vue?vue&type=script&lang=js&"
export * from "./Bara.vue?vue&type=script&lang=js&"
import style0 from "./Bara.vue?vue&type=style&index=0&id=73264d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73264d96",
  null
  
)

export default component.exports